<c-modal
  class="auth-fullpage"
  id="liveDemoModal"
  backdrop="static"
  [visible]="visible"
  (visibleChange)="backdropClick($event)"
>
  <c-modal-header>
    <svg [cIcon]="icons.cibAdguard" size="l"></svg>
    <h5 cModalTitle>{{ 'AUTH_MFA_MODAL_SETTINGS_TITTLE' | translate }}</h5>
    <button (click)="toggleVisibility(false)" cButtonClose>&nbsp;</button>
  </c-modal-header>
  <c-modal-body [style.direction]="authService.language.direction">
    {{ 'AUTH_MFA_MODAL_SETTINGS_HEADER' | translate }}
    <app-control-resend-code
      [parentComponent]="this"
      [info]="'AUTH_MFA_MODAL_SETTINGS_DESTINATION'"
    ></app-control-resend-code>
  </c-modal-body>
  <c-modal-footer>
    <button (click)="toggleVisibility(false)" cButton color="secondary">
      {{ 'SHARED_BUTTON_CANCEL' | translate }}
    </button>
  </c-modal-footer>
</c-modal>
